<template>
	<NavbarComponent />
	<MainComponent />
	<FooterComponent />
</template>

<script setup>
import { onMounted } from 'vue';

import NavbarComponent from './components/NavbarComponent.vue';
import MainComponent from './components/MainComponent.vue';
import FooterComponent from './components/FooterComponent.vue';

import sendAnalytic from '@/common/sendAnalytic';

onMounted(() => {
	sendAnalytic('Event', 'View', 'Event_view');
});

</script>
